// extracted by mini-css-extract-plugin
module.exports = {"link":"Slide_link__lM0Ex","Slide":"Slide_Slide__2gwxh","ripple":"Slide_ripple__19iDL","lds-ripple":"Slide_lds-ripple__2NiRA"};